import { API_HOST } from '@/shared/constants/const'

/**
 * 法人ごとの困ったときガイドと、紙の店舗シート (印刷用 PDF) の行き先。
 *
 * **どの版かを決めるのは back。** front は法人 UUID の表を持たず、薬局コンテキスト
 * (`/api/me/pharmacy/` の `guide_variant`) が返す版名を受け取るだけ
 * (design-book ADR-0051)。法人 UUID は DB の事実で本番と staging では別の値になるため、
 * front の bundle に焼くと片方の環境で死にキーになる。
 *
 * 版名は back の `users/guide_variant.py`・S3 のキー・Figma の紙と 1:1。
 *
 * 連絡先はここに持たない。困ったときの入口はガイド 1 つで、連絡先はガイドの中の
 * 「それでも解決しないとき」(variants/*.tsx) だけが持つ — 同じことを 2 か所に書かない
 * (design-book ADR-0048)。
 */
export const KAKERU_GUIDE_VARIANTS = ['default', 'aisei'] as const

export type KakeruGuideVariant = (typeof KAKERU_GUIDE_VARIANTS)[number]

export const DEFAULT_KAKERU_GUIDE_PATH = '/guide'

/** back が解決した版名を受ける。取得前・知らない版名は共通版 */
export const kakeruGuideVariantOf = (
  name?: string | null
): KakeruGuideVariant =>
  KAKERU_GUIDE_VARIANTS.find((variant) => variant === name) ?? 'default'

/** 困ったときガイドの行き先。App.tsx の route もこの関数から組む (パスを 2 か所に書かない) */
export const kakeruGuidePath = (variant: KakeruGuideVariant): string =>
  variant === 'default'
    ? DEFAULT_KAKERU_GUIDE_PATH
    : `${DEFAULT_KAKERU_GUIDE_PATH}/${variant}`

/**
 * 紙の店舗シート (A4 表裏) の印刷用 PDF。版は back が session から解決するので、
 * URL に版名は入らない (design-book ADR-0051)。back は S3 のキーを組んで署名付き URL へ
 * 302 する (yakureki-back `yakureki/views_guide.py`)。PDF を front に同梱しないのは、
 * 紙を 1 行直すたびに front の release が要るため (ADR-0046)。
 */
export const KAKERU_GUIDE_PDF_URL = `${API_HOST}/api/guide/pdf/`
